// Competitive Intel V2 realtime (handoff §3). Signals carry ids only: on a signal, read the data again
// over REST. After a reconnect, read the report again (signals sent while the socket was down are
// lost); while the socket is down and something is working on the report, poll every 15 s.

export const REVERB_ENABLED = Boolean(process.env.REACT_APP_REVERB_KEY);

/** Private channel of one V2 report (any member who can see the report may subscribe). */
export const ciReportChannel = (reportId) => `competitive-intel-report.${reportId}`;

export const CI_SIGNAL = {
  REPORT_UPDATED: '.report.updated',
  SETUP_STEP_UPDATED: '.setup-step.updated',
  VALIDATION_UPDATED: '.validation.updated',
  COMPETITORS_UPDATED: '.competitors.updated',
  RUN_STATE: '.run.state',
  RUN_FEED: '.run.feed',
  REPORT_PUBLISHED: '.report.published',
};

export const CI_POLL_MS = 15000;

/** Report `status` values (handoff §7). */
export const CI_REPORT_STATUS = {
  PENDING: 'pending',
  VALIDATING: 'validating',
  VALIDATED: 'validated',
  DISCOVERING: 'discovering',
  DISCOVERED: 'discovered',
  PROCESSING: 'processing',
  CANCELLING: 'cancelling',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  ARCHIVED: 'archived',
};

/** Report page `state` values (handoff §7). */
export const CI_PAGE_STATE = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

/** Something is working on the report: a build with nothing on show yet, or an update. */
export const isCiReportWorking = (report) =>
  Boolean(report) &&
  (report.state === CI_PAGE_STATE.IN_PROGRESS ||
    report.state === CI_PAGE_STATE.NOT_STARTED ||
    Boolean(report.runInProgress));
